import React, { useContext, useState } from "react";
import { EditorInfoContext } from "../../../../../utis/userInfoContext";
import PdfElement from "../pdfEditorElements/PdfElement";
import { getNormalizedDimensions, normalizeDimensions, dispatchEvent } from "../../../../../utis/helper";
import { elementHasActiveAction } from "../../../../../hooks/utils";

const PdfElementsList = ({
  timerOnDoc,
  setVideoData,
  actionCableVideoMontior,
  elemClick,
  trackPageChange,
  zoom,
  docFileId,
  index,
  canvasRefs,
  editortype,
  hoveredId,
  setJumpPageNum,
}) => {
  const {
    elements,
    pageNumber,
    setPageNumber,
    pageDimensions,
    isActionDisabled,
  } = useContext(EditorInfoContext);

  const [resizeDimensions, setResizeDimensions] = useState({});
  const [actionElement, setActionElement] = useState({});

  const arrayOfElements =
    Object.values(Object.entries(elements).length !== 0 && elements);

  const handleAction = (element) => {
    const { desiredaction, thisElement } = element?.dropdown_data;
    if (element?.dropdown_data && desiredaction && thisElement) {
      setActionElement({
        ...actionElement,
        [thisElement == "thisElement" ? element?.id : thisElement]: {
          targetElement:
            thisElement == "thisElement" ? element?.id : thisElement,
          visibility:
            desiredaction === "hide"
              ? false
              : desiredaction === "reveal"
              ? true
              : actionElement[thisElement]?.visibility == undefined
              ? false
              : !actionElement[thisElement]?.visibility,
        },
      });
    }
  };

  const handlePDFChangeAction = (value) => {
    // CYOA mode: page visibility is controlled via current-page-container class,
    // not by scrolling. scrollIntoView with position:fixed body crashes iOS Safari.
    const isCYOA = document.querySelector('.hidden-for-cyoa') !== null;
    if (!isCYOA) {
      const allCanvasElements = document.getElementsByClassName("react-pdf__Page");
      const canvasArray = Array.from(allCanvasElements);
      const targetCanvas = canvasArray.find(
        (canvas) => canvas.getAttribute("data-page-number") === `${value}`
      );
      if (targetCanvas) {
        targetCanvas.scrollIntoView({ behavior: "instant" });
      }
    }
    setPageNumber(value);
    try {
      trackPageChange?.(Number(value));
    } catch (e) {
      // non-fatal
    }
    const input = document.getElementById("pageNumber");
    if (input) {
      input.value = value;
      dispatchEvent("change", "pageNumber");
    }
  };

  return (
    <>
      {arrayOfElements &&
        arrayOfElements?.map((element) => {
          if (
            docFileId == element?.docs_file_id &&
            element?.geometry?.top !== null &&
            element?.geometry?.left !== null &&
            element?.geometry?.height !== null &&
            element?.geometry?.top !== null &&
            index + 1 === element?.page
          ) {
            const canvas = canvasRefs?.current?.[index];
            const pagedim = pageDimensions;

            // getNormalizedDimensions already converts saved geometry into
            // CSS pixel space for the current page/canvas.
            const { geo } = getNormalizedDimensions(
              element.geometry,
              zoom?.value ?? 1,
              { ...pagedim },
              element,
              canvas
            );

            // ---- CRITICAL CHANGE (stats-only) ----
            // For stats-viewer, use `geo` directly. Editor/Viewer keep existing logic.
            const useGeoDirectly = editortype === "stats-viewer";

            // Fallback zooms if needed
            const baseZoom =
              typeof window !== "undefined" &&
              window.objInit &&
              Number(window.objInit.zoom_lvl)
                ? Number(window.objInit.zoom_lvl)
                : 1;
            const currentZoom = Number(zoom?.value) || 1;

            const dimensions = useGeoDirectly
              ? {
                  // Use geo if present; minimal fallback to normalizeDimensions
                  top:
                    geo?.top ??
                    normalizeDimensions(
                      element?.geometry?.top,
                      baseZoom,
                      currentZoom
                    ),
                  left:
                    geo?.left ??
                    normalizeDimensions(
                      element?.geometry?.left,
                      baseZoom,
                      currentZoom
                    ),
                  height:
                    geo?.height ??
                    normalizeDimensions(
                      element?.geometry?.height,
                      baseZoom,
                      currentZoom
                    ),
                  width:
                    geo?.width ??
                    normalizeDimensions(
                      element?.geometry?.width,
                      baseZoom,
                      currentZoom
                    ),
                }
              : {
                  // Editor/Viewer: keep old behavior
                  top: geo?.top,
                  left: geo?.left,
                  height: geo?.height,
                  width: geo?.width,
                };

            const isHotspotOrImage =
              element?.element_type_name === "Hotspot" ||
              element?.element_type_name === "Image";
            const hasActiveAction = elementHasActiveAction(element);
            const showPointerCursor =
              editortype === "editor" && isHotspotOrImage && hasActiveAction;

            return (
              <div
                id={"div" + element?.id}
                key={element?.id}
                style={{
                  ...geo,
                  position: "absolute",
                  userSelect: "none",
                  zIndex: Number(99) + Number(element?.order_on_page),
                  top: `${
                    resizeDimensions[element.id]?.top ?? dimensions.top ?? 0
                  }px`,
                  left: `${
                    resizeDimensions[element.id]?.left ?? dimensions.left ?? 0
                  }px`,
                  width: `${
                    resizeDimensions[element.id]?.width ?? dimensions.width ?? 0
                  }px`,
                  height: `${
                    resizeDimensions[element.id]?.height ??
                    dimensions.height ??
                    0
                  }px`,
                  visibility:
                    Number(element?.id) ===
                    Number(actionElement[element?.id]?.targetElement)
                      ? actionElement[element?.id]?.visibility
                        ? "visible"
                        : "hidden"
                      : undefined,
                  transform: `
                    rotate(${element?.rotate ?? 0}deg)
                    scale(${hoveredId === element.id ? 1.1 : 1})
                  `,
                  backgroundColor:
                    hoveredId === element?.id
                      ? "rgba(255, 255, 127, 0.9)"
                      : "transparent",
                  transition: "transform 0.3s ease, background-color 0.3s ease",
                  cursor: showPointerCursor ? "pointer" : undefined,
                }}
                onClick={(eve) => {
                  element?.dropdown_data && handleAction(element);
                  elemClick(element.id, eve, element);
                  
                   if (element?.value?.reactive) {
          if (window?.objInit?.tlb) {
              window.objInit.tlb.disable_scroll = false;

    // Remove any global blockers
    document.body.classList.remove("scroll_disable");
    document.body.style.overflow = "auto";

    const wrapper = document.getElementById("parent_doc_wrapper");
    if (wrapper) {
      wrapper.style.overflowY = "scroll";  // force re-enable scroll
      wrapper.style.overflow = "auto";     // just in case
    }
    const pdfElementList = document.getElementsByClassName("viewer-bg");

    Array.from(pdfElementList).forEach(el => {
      el.classList.remove("scroll_disable", "hidden-for-cyoa");
    });
          
          }
        }
      


                }}
              >
                <PdfElement
                  element={element}
                  disableClick={editortype === "editor" ? isActionDisabled : false}
                  canvasRef={canvas}
                  zoom={zoom}
                  setVideoData={setVideoData}
                  actionCableVideoMontior={actionCableVideoMontior}
                  dimensions={dimensions}
                  setPageNumber={(value) => handlePDFChangeAction(value)}
                  editortype={editortype}
                  setResizeDimensions={setResizeDimensions}
                  resizeDimensions={resizeDimensions}
                  timerOnDoc={timerOnDoc}
                  elemClick={elemClick}
                  setJumpPageNum={setJumpPageNum}
                  handleAction={handleAction}
                />
              </div>
            );
          }
          return null;
        })}
    </>
  );
};

export default PdfElementsList;
